import { Badge } from '@mantine/core'
import type { MedicationRequest } from '@medplum/fhirtypes'
import { doseSpotStatusPill, isDoseSpotTransmissionError } from './doseSpotPrescription'

type Props = {
  prescription: MedicationRequest
}

/**
 * DoseSpot's own two-axis status, verbatim (`eRxSent · Active`) — the pill both the
 * Medications table and the chronological-record panel show in place of the derived FHIR
 * `status`, because FHIR's vocabulary cannot say `Error` and a prescription the pharmacy
 * never received is exactly what a prescriber needs to see (§10.6, §11.5).
 *
 * Red is reserved for that failed-transmission case; everything else is neutral, so the
 * colour carries the one distinction the raw pill exists for.
 */
export function DoseSpotStatusBadge({ prescription }: Props) {
  return (
    <Badge
      size="sm"
      variant="light"
      color={isDoseSpotTransmissionError(prescription) ? 'red' : 'gray'}
    >
      {doseSpotStatusPill(prescription)}
    </Badge>
  )
}
